import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';


@Component({
  selector: 'app-college-approval-list',
  templateUrl: './college-approval-list.component.html',
  styleUrls: ['./college-approval-list.component.scss']
})
export class CollegeApprovalListComponent implements OnInit {
  public activeTab: 'Draft' | 'InActive' | 'Active' = 'Draft';

  public colleges: any[] = [];
  public filteredColleges: any[] = [];
  public searchText: string = '';
  public isLoading: boolean = false;
  public message: string = '';
  public class: string = '';

  // Pagination properties
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalItems: number = 0;

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadPendingColleges();
  }

  loadPendingColleges() {
    this.isLoading = true;
    this.http.get<any>(`${environment.apiUrl}/college`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => {
        this.isLoading = false;
        if (data.message === "Logged Out!") {
          this.router.navigateByUrl("/auth/login");
          return;
        }

        this.colleges = data.results || data;
        this.applyTabFilter();
        this.totalItems = this.filteredColleges.length;

        if (this.colleges.length === 0) {
          this.message = "No colleges waiting for approval";
          this.class = "alert-info";
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        console.error('Error loading pending colleges:', error);
        this.message = "Error loading colleges";
        this.class = "alert-danger";
      }
    );
  }

  applyTabFilter() {
    // filter by tab status
    this.filteredColleges = this.colleges.filter(
      c => c.status === this.activeTab
    );

    // apply search if needed
    if (this.searchText) {
      const searchLower = this.searchText.toLowerCase();
      this.filteredColleges = this.filteredColleges.filter(college =>
        college.collegename?.toLowerCase().includes(searchLower) ||
        college.universityDetails?.name?.toLowerCase().includes(searchLower) ||
        college.cityDetails?.name?.toLowerCase().includes(searchLower)
      );
    }

    this.totalItems = this.filteredColleges.length;
    this.currentPage = 1;
  }

  applyFilter() {
    this.applyTabFilter();
  }

  deactivateCollege(college: any) {
  if (!confirm(`Deactivate ${college.collegename}?`)) return;

  this.http.put<any>(
    `${environment.apiUrl}/college/${college._id}`,
    { status: 'InActive' },
    { headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      }, }
  ).subscribe(() => {

    this.message = `${college.collegename} deactivated`;
    this.class = 'alert-warning';

    // ✅ update status locally
    const item = this.colleges.find(c => c._id === college._id);
    if (item) {
      item.status = 'InActive';
    }

    this.applyTabFilter();
  });
}



  editCollege(collegeId: string) {
    this.router.navigate([
      '/college-details/college-form-list',
      collegeId
    ]);
  }


  viewCollege(collegeId: string) {
    this.router.navigate([`/college-details/view-college-application/${collegeId}`]);
  }

  approveCollege(college: any) {
    if (!confirm(`Approve ${college.collegename}?`)) return;

    this.http.put<any>(
      `${environment.apiUrl}/college/${college._id}`,
      { status: 'Active' },
      { headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem('adminSess'),
            role: localStorage.getItem('userRole'),
          }),
        }, }
    ).subscribe(() => {

      this.message = `${college.collegename} approved`;
      this.class = 'alert-success';

      // ✅ update status locally
      const item = this.colleges.find(c => c._id === college._id);
      if (item) {
        item.status = 'Active';
      }

      // refresh tab view
      this.applyTabFilter();
    });
  }


  rejectCollege(college: any) {
    const reason = prompt('Please provide a reason for rejection:');
    if (reason !== null) {
      this.http.patch<any>(`${environment.apiUrl}/college/${college._id}`,
        { status: 'rejected', rejectionReason: reason },
        {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        }
      ).subscribe(
        (response) => {
          if (response.message === "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }

          this.message = `${college.collegename} has been rejected`;
          this.class = "alert-warning";

          // Remove from list
          this.colleges = this.colleges.filter(c => c._id !== college._id);
          this.applyFilter();
        },
        (error: HttpErrorResponse) => {
          console.error('Error rejecting college:', error);
          this.message = "Error rejecting college";
          this.class = "alert-danger";
        }
      );
    }
  }

  // Pagination methods
  get paginatedColleges() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredColleges.slice(startIndex, startIndex + this.itemsPerPage);
  }

  changePage(page: number) {
    this.currentPage = page;
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get pages(): number[] {
    const pages = [];
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }
}